// import Swiper and modules styles
import '../css/swiper.css';

import cookie from './cookie.ts';
import header from './header_sticky.ts';
import swipersPersonalizados from './swipers_personalizados.ts';
import menu from './menu.ts';
import alert from './alert.ts';
import video from './video.ts';
import faqs from './faqs.ts';
import contacto from './contacto.ts';
import animation1 from './animation-home.ts';
import animation2 from './animation-nuestra-escuela.ts';
import animation3 from './animation-nuestro-equipo.ts';
import photoSliderProf from './photo-slider-prof.ts';
import { initContact } from './contact/contact';

header();
alert();
video();
menu();
cookie();
animation1();
animation2();
animation3();
contacto();
swipersPersonalizados();
faqs();
photoSliderProf();
initContact();
